import React, { useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useLanguage } from '../../../contexts/LanguageContext';

const BlockShelfSeqItemDescriptionTable = ({
    items = [],
    totalCount = 0,
    loading = false,
    lazyParams,
    activeFilters = {},
    onFiltersChange,
    sortField,
    sortOrder,
    onSortChange,
    onPage,
    onEdit
}) => {
    const { th } = useLanguage();
    const timerRef = useRef(null);

    const [localFilters, setLocalFilters] = useState(activeFilters || {});

    const handleFilterInputChange = (field, value) => {
        console.log('FILTER TYPED:', field, value);

        const updatedFilters = {
            ...localFilters,
            [field]: value
        };

        setLocalFilters(updatedFilters);

        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        timerRef.current = setTimeout(() => {
            console.log('SEND FILTER:', updatedFilters);
            onFiltersChange(updatedFilters);
        }, 500);
    };

    const textFilterTemplate = (field, placeholder) => {
        return (
            <InputText
                value={localFilters?.[field] || ''}
                onInput={(e) => handleFilterInputChange(field, e.target.value)}
                placeholder={placeholder}
                className="p-column-filter w-full"
            />
        );
    };

    const actionBodyTemplate = (rowData) => (
        <Button
            icon="pi pi-pencil"
            className="p-button-rounded p-button-text"
            onClick={() => onEdit(rowData)}
        />
    );

    return (
    <DataTable
        value={items}
        lazy
        paginator
        filterDisplay="row"
        first={lazyParams?.first || 0}
        rows={lazyParams?.rows || 10}
        totalRecords={totalCount || 0}
        loading={loading}
        onPage={onPage}
        sortField={sortField}
        sortOrder={sortOrder}
        onSort={onSortChange}
        dataKey="id"
        emptyMessage={th('common.noRecords') || 'Kayıt bulunamadı'}
        responsiveLayout="scroll"
    >
        <Column
            field="partCode"
            header={th('blockShelfSeqItemDescription.partCode') || 'Parça Kodu'}
            sortable
            filter
            showFilterMenu={false}
            filterElement={() =>
                textFilterTemplate(
                    'partCode',
                    th('blockShelfSeqItemDescription.partCode') || 'Parça Kodu'
                )
            }
        />

        <Column
            field="partDesc"
            header={th('blockShelfSeqItemDescription.partDescription') || 'Parça Açıklaması'}
            sortable
            filter
            showFilterMenu={false}
            filterElement={() =>
                textFilterTemplate(
                    'partDesc',
                    th('blockShelfSeqItemDescription.partDescription') || 'Parça Açıklaması'
                )
            }
        />

        <Column
            field="block"
            header={th('blockShelfSeqItemDescription.block') || 'Blok'}
            sortable
            filter
            showFilterMenu={false}
            filterElement={() =>
                textFilterTemplate(
                    'block',
                    th('blockShelfSeqItemDescription.block') || 'Blok'
                )
            }
        />

        <Column
            field="shelf"
            header={th('blockShelfSeqItemDescription.shelf') || 'Raf'}
            sortable
            filter
            showFilterMenu={false}
            filterElement={() =>
                textFilterTemplate(
                    'shelf',
                    th('blockShelfSeqItemDescription.shelf') || 'Raf'
                )
            }
        />

        <Column
            field="sequence"
            header={th('blockShelfSeqItemDescription.sequence') || 'Sıra'}
            sortable
            filter
            showFilterMenu={false}
            filterElement={() =>
                textFilterTemplate(
                    'sequence',
                    th('blockShelfSeqItemDescription.sequence') || 'Sıra'
                )
            }
        />

        <Column
            field="eyes"
            header={th('blockShelfSeqItemDescription.eyes') || 'Göz'}
            sortable
            filter
            showFilterMenu={false}
            filterElement={() =>
                textFilterTemplate(
                    'eyes',
                    th('blockShelfSeqItemDescription.eyes') || 'Göz'
                )
            }
        />

        <Column
            body={actionBodyTemplate}
            header={th('common.actions') || 'İşlemler'}
            style={{ width: '6rem' }}
        />
    </DataTable>
    );
};

export default BlockShelfSeqItemDescriptionTable;